import { render, staticRenderFns } from "./SustainabilityFundTab.vue?vue&type=template&id=5497d908&scoped=true"
import script from "./SustainabilityFundTab.vue?vue&type=script&lang=js"
export * from "./SustainabilityFundTab.vue?vue&type=script&lang=js"
import style0 from "./SustainabilityFundTab.vue?vue&type=style&index=0&id=5497d908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497d908",
  null
  
)

export default component.exports